module.exports = __webpack_public_path__ + "static/media/lamina27img1.9ef9869e.png";